export default "/images/vendor/flag-icon-css/flags/1x1/al.svg?090568ab89f9b7e68f3bee7e93b0b48b";